/* @refresh reload */
import "./index.css";

import type { ComponentType } from "react";
import { ensureApiMocksInitialized } from "./mocks/api";

const AGENTATION_SHADOW_HOST_ID = "quantfi-agentation-shadow-host";
const AGENTATION_ROOT_ID = "quantfi-agentation-root";

const mountAgentationDevtool = async () => {
  if (!import.meta.env.DEV || typeof window === "undefined") {
    return;
  }

  if (document.getElementById(AGENTATION_SHADOW_HOST_ID)) {
    return;
  }

  const endpoint =
    import.meta.env.VITE_AGENTATION_ENDPOINT ?? "http://localhost:4747";

  try {
    const [{ Agentation }, { createElement }, { createRoot }] =
      await Promise.all([
        import("agentation"),
        import("react"),
        import("react-dom/client"),
      ]);

    const host = document.createElement("div");
    host.id = AGENTATION_SHADOW_HOST_ID;
    host.style.position = "fixed";
    host.style.inset = "0";
    host.style.zIndex = "2147483647";
    host.style.pointerEvents = "none";

    const shadowRoot = host.attachShadow({ mode: "open" });
    const mountNode = document.createElement("div");
    mountNode.id = AGENTATION_ROOT_ID;
    mountNode.style.pointerEvents = "auto";

    shadowRoot.append(mountNode);
    document.body.append(host);

    const reactRoot = createRoot(mountNode);
    const AgentationComponent = Agentation as ComponentType<{
      endpoint?: string;
    }>;
    reactRoot.render(createElement(AgentationComponent, { endpoint }));
  } catch (error) {
    console.error("Failed to mount Agentation devtool", error);
  }
};

void mountAgentationDevtool();

const bootstrap = async () => {
  await ensureApiMocksInitialized();
  const { mountApp } = await import("./bootstrap");
  mountApp();
};

void bootstrap();
